import { render, staticRenderFns } from "./newSupplier.vue?vue&type=template&id=67bd45a0&scoped=true"
import script from "./newSupplier.vue?vue&type=script&lang=js"
export * from "./newSupplier.vue?vue&type=script&lang=js"
import style0 from "./newSupplier.vue?vue&type=style&index=0&id=67bd45a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bd45a0",
  null
  
)

export default component.exports